import { commonBase } from '@kid/meta-color/color/output/all';
import { useStyle } from '../../hooks/useStyle';
const SizeMap = {
    mini: 24,
    small: 32,
    middle: 40,
    large: 48,
    huge: 56,
};
const BorderRadusMap = {
    mini: 4,
    small: 6,
    middle: 6,
    large: 6,
    huge: 6,
};
export const NodeGap = {
    mini: 4,
    small: 6,
    middle: 6,
    large: 8,
    huge: 8,
};
export const useButtonStyle = ({ size, block = false, shape = 'rect', ghost = false, }) => {
    const finalHeight = SizeMap[size] || SizeMap['middle'];
    const sizeStyle = useStyle({
        mini: {
            borderRadius: 4,
            paddingHorizontal: 8,
        },
        small: {
            borderRadius: 6,
            paddingHorizontal: 12,
        },
        middle: {
            borderRadius: 6,
            paddingHorizontal: 16,
        },
        large: {
            borderRadius: 8,
            paddingHorizontal: 32,
        },
        huge: {
            borderRadius: 8,
            paddingHorizontal: 48,
        },
    });
    const fontStyle = useStyle({
        mini: {
            fontSize: 12,
            fontWeight: '500',
        },
        small: {
            fontSize: 14,
            fontWeight: '500',
        },
        middle: {
            fontSize: 16,
            fontWeight: '500',
        },
        large: {
            fontSize: 18,
            fontWeight: '700',
        },
        huge: {
            fontSize: 20,
            fontWeight: '700',
        },
    });
    const themeStyles = useStyle({
        base: {
            alignSelf: block ? 'stretch' : 'baseline',
            height: finalHeight,
            borderRadius: BorderRadusMap[size] || BorderRadusMap['middle'],
        },
        primary: Object.assign({ backgroundColor: commonBase.kiui_color_base_red_1 }, (ghost
            ? {
                borderColor: commonBase.kiui_color_base_red_1,
            }
            : {})),
        white: Object.assign({ backgroundColor: commonBase.kiui_color_base_white_1 }, (ghost
            ? {
                borderColor: commonBase.kiui_color_base_white_1,
            }
            : {})),
        default: {
            backgroundColor: 'transparent',
            borderWidth: 1,
            borderColor: commonBase.kiui_color_base_black_1_a12,
        },
    });
    const colorStyle = useStyle({
        primary: {
            lineHeight: 20,
            color: ghost
                ? commonBase.kiui_color_base_red_1
                : commonBase.kiui_color_base_white_1,
        },
        white: {
            color: ghost
                ? commonBase.kiui_color_base_white_1
                : commonBase.kiui_color_base_black_1_a88,
        },
        default: {
            color: commonBase.kiui_color_base_black_1_a88,
        },
    });
    const ghostStyle = useStyle({
        ghost: {
            borderWidth: 1,
            backgroundColor: 'transparent',
        },
    });
    const roundStyle = useStyle({
        round: {
            borderRadius: finalHeight / 2,
        },
    });
    return {
        sizeStyle,
        themeStyles,
        colorStyle,
        roundStyle,
        fontStyle,
        ghostStyle,
    };
};
